import { sendString } from "./sends"

var LoginAdapters = {

    POST: {

        send: {

            schema: function (item: any = {}) {

                return {
                    // username: sendString(item.username),
                    // password: sendString(item.password),
                }
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {

            schema: function (item: any = {}) {

                return {
                    token: item.token
                }
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },

}

// Login con certificado digital.
//
// No habla con la API directamente: `public/valida/index.php` es un proxy PHP same-origin
// que lee el certificado de cliente del handshake TLS (`$_SERVER['SSL_CLIENT_CERT']`) y lo
// reenvía a la API. Del body solo usa dos claves, y por su nombre exacto:
//   - `api`: la base de la API, con la que el PHP compone la url de destino.
//   - `nifCert`: el NIF que escribe el usuario.
// El `send` las manda así, en mayúsculas y sin espacios, y no manda nada más.
//
// En la respuesta se espera `{ token }`, igual que en el login normal
// (`JwtAuthenticationResponse`); el `schema` acepta también el token envuelto
// (`{ data: { token } }`) por si el endpoint acaba devolviéndolo así.
const LoginCertificadoAdapters = {

    POST: {

        send: {

            schema: function (item: any = {}) {

                return {
                    api: process.env.REACT_APP_API_URL,
                    nifCert: String(item.nif || '').toUpperCase().trim(),
                }
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {

            schema: function (item: any = {}) {

                return {
                    token: item?.token ?? item?.data?.token
                }
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },

}

const TokenAdapters = {

    POST: {

        send: {

            schema: function (item: any = {}) {

                return {
                    // username: sendString(item.username),
                    // password: sendString(item.password),
                }
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {

            schema: function (item: any = {}) {

                return item
            },

            adapter: function (data: any) {

                const dataTemp = data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },

}

const ResetEmailAdapters = {

    GET: {

        receive: {

            schema: function (item: any = '') {

                return item
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },

    POST: {

        send: {

            schema: function (item: any) {

                if (!item) item = {}

                var data = {
                    password: sendString(item.password),
                    token: sendString(item.token),
                }

                return data
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },
    },
}

export {
    LoginAdapters,
    LoginCertificadoAdapters,
    ResetEmailAdapters,
    TokenAdapters,
}